import React, { useState, useEffect } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';

function InergenModal({ taskLineInergen, handleTaskLineInergen }) {
  const [show, setShow] = useState(false);

  const inergenFields = [['', ''],
  ['Centralskab', 'Centralskab'],
  ['Udloserbox', 'Udløserbox'],
  ['Nodstrom', 'Nødstrøm'],
  ['BrandmelderType', 'Brandmelder-type'],
  ['BrandmelderAntal', 'Brandmelder antal'],
  ['BrandmelderSkjulte', 'Brandmelder skjulte'],
  ['Maskinstop', 'Maskinstop (Serviceafbryder)'],
  ['Alarmoverforsel', 'Alarmoverførsel'],
  ['TransModtager', ''],
  ['VentilType', 'Ventil-type'],
  ['BeholderAntal', 'Beholder-antal'],
  ['BeholderBem', 'Beholder-type'],
  ['PlaceringSkab', 'Placering-Skab'],
  ['TableauAntal', 'Tableu antal'],
  ['TableauBem', 'Tableau bemærkning'],
  ['Udskiftet', 'Udskiftet den'],
  ['InstallDate', 'Installationsdato'],
  ['PlaceringBeholder', 'Placering-Beholder'],
  ['Comment1', ''],
  ['Comment2', ''],
  ['Comment3', ''],
  ['SpecComment1', 'Særlige bem. 1'],
  ['SpecComment2', 'Særlige bem. 2'],
  ['SpecComment3', 'Særlige bem. 3'],
  ['SingleShot', ''],
  ['Ventilationsstop', 'Ventilationsstop'],
  ['Aktuartype', 'Aktuartype'],
  ['ASPFilter', ''],
  ['Trykspjaeld', 'Trykspjæld'],
  ['BeholderAarstal', 'Beholder-Årstal'],
  ['BrandmelderDato', ''],
  ['PhysicalLocation1', ''],
  ['PhysicalLocation2', ''],
  ['ReplacementDate', ''],
  ['Rate', ''],
  ['SpecialComment', ''],
  ['RateCorrected', ''],
  ['ModelCode', ''],
  ['X_Serviced', 'Efterset'],
  ['X_Repaired', 'Repareret'],
  ['X_Refilled', 'Opladet'],
  ['X_FireAlarmTest', 'Brandalarmtest (A+B - manuel tryk/ASP)'],
  ['X_ErrorSurveillanceTest', 'Fejlovervågningstest'],
  ['X_LeakageAlarm', 'Lækagealarm'],
  ['X_TestofAlarmUnits', 'Test af alarmgivere'],
  ['X_TestofTriggerSignal', 'Test af udløsersignal (A+B - manuel tryk/ASP)'],
  ['X_ExtinguishingMediaControl', 'Slukn. Middel kontr. V. vejning/væskestandsmåler/manometer'],
  ['X_ActuatorControl', 'Aktuar kontrolleret'],
  ['X_ChargingVoltage', 'Ladespænding'],
  ['X_BatteryCheck', 'Battericheck'],
  ['X_NozzleControl', 'Dyser kontrolleret'],
  ['X_PressureDamper', 'Trykspjæld'],
  ['X_HosesTubesControl', 'Slanger, rør, beslag kontrolleret for tilspænding'],
  ['X_TransmissionSignalError', 'Transmissionssignal, fejl'],
  ['X_TransmissionSignalFire', 'Transmissionssignal, brand'],
  ['X_Machinestop', 'Maskinstop'],
  ['X_VentilationStop', 'Ventilationsstop'],
  ['X_FilterASP', 'Filter ASP.']];

  const handleClose = () => {
    handleTaskLineInergen(null)
    setShow(false)
  }
  useEffect(() => {
    if (taskLineInergen) {
      setShow(true)
    }
  }, [taskLineInergen])
  if (!taskLineInergen) {
    return <></>
  }
  const taskLine = taskLineInergen;
  const inergentoptable = () => {
    const inergentoptablecolumns = [39, 40, 41];
    return (
      <Row className="mb-3">
        {taskLine.location ? <Col sm="auto">{taskLine.location}</Col> : null}
        {
          inergentoptablecolumns.map((column) => {   
            const field = inergenFields[column];
            const inergenValue = taskLine.inergen[Object.keys(taskLine.inergen).find(key => key.toLowerCase() === field[0].toLowerCase())];
            const value = inergenValue === "" ? "-" : "X";
            return (
              <Col key={column}>
                <Row>
                  <Col sm="auto" className={value === "X" ? "checked" : "notchecked"}>{value}</Col>
                  <Col className="lbl">{field[1]}</Col>
                </Row>
              </Col>
            )
          })
        }
      </Row>
    )
  }
  const inergenfieldstable = () => {
    const inergenfieldstablecolumns = [[1, 2, 3, 4, 7, 8, 10, 11, 27], [13, 14, 15, 16, 5, 6, 17, 18, 30, 29]];
    return (
      <Row className="mb-3">
        {
          inergenfieldstablecolumns.map((column) => {
            return (
              <Col key={column} sm={6}>
                {
                  column.map((col) => {
                    const field = inergenFields[col];
                    const value = taskLine.inergen[Object.keys(taskLine.inergen).find(key => key.toLowerCase() === field[0].toLowerCase())];
                    return (
                      <Row key={col}>
                        <Col sm="auto" className="lbl">{field[1]}</Col>
                        <Col sm="auto">{value}</Col>
                      </Row>
                    )
                  })
                }
              </Col>
            )
          })
        }
      </Row>
    )
  }
  const inergenchecktable = () => {
    const inergenchecktablecolumns = [[42, 43, 44, 45, 46, 47, 48, 49, 52], [51, 54, 55, 56, 53, 50, 57, 58]];
    return (
      <Row className="mb-3">
        {
          inergenchecktablecolumns.map((column) => {
            return (
              <Col key={column} sm={6}>
                {
                  column.map((col) => {
                    const field = inergenFields[col];
                    const inergenValue = taskLine.inergen[Object.keys(taskLine.inergen).find(key => key.toLowerCase() === field[0].toLowerCase())];
                    const value = inergenValue === "" ? "-" : "X";
                    return (
                      <Row key={col}>
                        <Col sm="auto" className={value === "X" ? "checked" : "notchecked"}>{value}</Col>
                        <Col className="lbl">{field[1]}</Col>
                      </Row>
                    )
                  })
                }
              </Col>
            )
          })
        }
      </Row>
    )
  }
  const inergencommenttable = () => {
    const inergencommenttablecolumns = [22, 23, 24];
    return (
      <Row>
        {
          inergencommenttablecolumns.map((column) => {
            const field = inergenFields[column];
            const value = taskLine.inergen[Object.keys(taskLine.inergen).find(key => key.toLowerCase() === field[0].toLowerCase())];
            return (
              <Row key={column}>
                <Col className="lbl">{field[1]}</Col> <Col>{value}</Col>
              </Row>
            )
          })
        }
      </Row>
    )
  }

  return (
    <Modal
      size="xl"
      show={show}
      onHide={() => handleClose()}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Inergen
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {inergentoptable()}
        {inergenfieldstable()}
        {inergenchecktable()}
        {inergencommenttable()}
      </Modal.Body>
    </Modal>
  )
}
export { InergenModal };
